<template>
  <div class="u-16">
    <div class="u grid between cross-center ver-padding-20">
      <h2 class="u">Все сплиты по заказу</h2>
    </div>

    <b-table
      :data="orderSplit"
      striped
      narrowed
      mobile-cards
      class="u-16 splits-info"
    >
      <template slot-scope="props" slot="default">
        <b-table-column
          field="date_created"
          label="Дата"
          sortable
          width="140"
          >{{ props.row.date_created | momentFormat() }}</b-table-column
        >
        <b-table-column
          field="split_terminal_id"
          label="Терминал контрагента"
          width="180"
          >{{ terminalName(props.row.split_terminal_id) }}</b-table-column
        >
        <b-table-column field="state_id" label="Статус">
          <span class="status-tag" :class="statusStyle(props.row.state_id)">{{
            statusName(props.row.state_id)
          }}</span>
        </b-table-column>
        <b-table-column field="amount" label="Сумма" width="100"
          >{{ props.row.amount | amountFormat }}
          {{ currencyCharacter(currencyCode) }}</b-table-column
        >
        <b-table-column field="purpose" label="Назначение" class="td-purpose">{{
          props.row.purpose
        }}</b-table-column>
      </template>

      <template slot="empty">
        <section>
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad"></b-icon>
              <br />Нет данных
            </p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import Vuex from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";
import { _ } from "underscore";
import VueAxios from "vue-axios";
export default {
  name: "OrderSplit",
  props: ["orderSplit", "currencyCode", "transactionOrderId"],
  data() {
    return {
      isFull: false
    };
  },
  methods: {},
  computed: {
    ...mapGetters([
      "terminalName",
      "currencyCharacter",
      "statusName",
      "statusStyle"
    ])
  }
};
</script>

<style lang="sass"></style>
